<template>
    <transition name="toastfade">
        <div :class="showMsg? 'nut-toastHov' : 'nut-toast'" v-show="show">{{msg}}</div>
    </transition>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            showMsg: false,
            msg: '',
        };
    },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/px2rem.scss';
// 设计稿宽度
$designWidth: 375;
.nut-toast {
    position: fixed;
    left: 50%;
    top: 30%;
    padding: px2rem(10) px2rem(15);
    max-width: 75%;
    text-align: center;
    pointer-events: none;
    z-index: 9999;
    transform: translateX(-50%);
    color: #fff;
    font-size: px2rem(14);
    line-height: px2rem(20);
    border-radius: px2rem(4);
    background-color: rgba(0, 0, 0, .7);
    box-shadow: 0 0 px2rem(10) 0 rgba(0,0,0,0.1);
}
.nut-toastHov {
   position: fixed;
    left: 50%;
    top: 45%;
    padding: px2rem(3) px2rem(5);
    max-width: 75%;
    text-align: center;
    pointer-events: none;
    z-index: 9999;
    transform: translateX(-50%);
    color: #fff;
    font-size: px2rem(4);
    line-height: px2rem(6);
    border-radius: px2rem(4);
    background-color: rgba(0, 0, 0, .7);
    box-shadow: 0 0 px2rem(10) 0 rgba(0,0,0,0.1);
}
.toastfade-enter-active {
  transition: opacity 0.1s;
}

.toastfade-leave-active {
  transition: opacity 0.3s;
}

.toastfade-enter,
.toastfade-leave-active {
  opacity: 0;
}
</style>
